/* Isolated UGC interactions, including Shopify section reloading. */
(() => {
  'use strict';

  const puzUgcBoundRoots = new WeakSet();

  function puzUgcBind(root) {
    if (puzUgcBoundRoots.has(root)) return;
    puzUgcBoundRoots.add(root);

    const gallery = root.querySelector('.puz-ugc__gallery');
    const videos = Array.from(root.querySelectorAll('.puz-ugc__frame video'));

    videos.forEach(video => {
      const frame = video.closest('.puz-ugc__frame');
      const playButton = frame.querySelector('[data-puz-ugc-play]');
      const errorMessage = frame.querySelector('.puz-ugc__error');

      function showError() {
        if (errorMessage) errorMessage.hidden = false;
        if (playButton) playButton.hidden = true;
      }

      video.addEventListener('play', () => {
        videos.forEach(other => {
          if (other !== video) other.pause();
        });
        if (playButton) playButton.hidden = true;
        if (errorMessage) errorMessage.hidden = true;
      });

      video.addEventListener('ended', () => {
        if (playButton) playButton.hidden = false;
      });

      video.addEventListener('error', showError);

      // A failed source can report its error before the video emits one.
      video.querySelectorAll('source').forEach(source => {
        source.addEventListener('error', showError);
      });

      if (playButton) {
        playButton.addEventListener('click', async () => {
          if (playButton.disabled) return;
          playButton.disabled = true;
          try {
            video.muted = false;
            await video.play();
          } catch (error) {
            // Another card or a hidden tab may intentionally interrupt play().
            if (!error || error.name !== 'AbortError') showError();
          } finally {
            playButton.disabled = false;
          }
        });
      }
    });

    if (gallery) {
      root.querySelectorAll('[data-puz-ugc-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const card = gallery.querySelector('.puz-ugc__card');
          if (!card) return;
          const direction = button.dataset.puzUgcDirection === 'previous' ? -1 : 1;
          const gap = Number.parseFloat(getComputedStyle(gallery).columnGap) || 0;
          const step = card.getBoundingClientRect().width + gap;
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          gallery.scrollBy({ left: direction * step, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      });
    }
  }

  function puzUgcInit(scope) {
    if (scope instanceof Element && scope.matches('[data-puz-ugc]')) puzUgcBind(scope);
    if (scope && typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-puz-ugc]').forEach(puzUgcBind);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => puzUgcInit(document), { once: true });
  } else {
    puzUgcInit(document);
  }

  document.addEventListener('shopify:section:load', event => {
    puzUgcInit(event.target);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    document.querySelectorAll('[data-puz-ugc]').forEach(root => {
      root.querySelectorAll('.puz-ugc__frame video').forEach(video => video.pause());
    });
  });
})();
